import template from './labelsSelectDialog.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $state, $mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.CurrentAccount = null;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.CurrentAccount = $rootScope.CurrentAccount;

        ctrl.destroyWatch = eventService.onDialogLabelSelect((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                labels: params.labels,
                selectedLabels: params.selectedLabels,
                data: params.data,
                account: ctrl.CurrentAccount
              },
              template,
              controllerAs: '$ctrl',
              controller(labels, selectedLabels, data, account) {
                const ctr = this;
                ctr.labels = labels;
                ctr.selectedLabels = selectedLabels;
                ctr.data = data;
                ctr.account = account;

                ctr.gotToLabelsSettings = () => {
                  $mdDialog.cancel();
                  $state.transitionTo('settings.labels');
                };

                ctr.labelsSelected = (selLabels, selData) => {
                  ctr.selectedLabels = selLabels;
                  ctr.data = selData;
                };

                ctr.confirm = () => {
                  $mdDialog.hide({ selectedLabels: ctr.selectedLabels, data: ctr.data });
                };

                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              ctrl.onFinished({ selectedLabels: result.selectedLabels, data: result.data });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
